export const SOFTLINE_API_CONSTRUCTION_PARTS =
  '/constructionparts-service/construction-parts/{{id}}';
export const SOFTLINE_API_CONSTRUCTION_PARTS_SUBMIT =
  '/constructionparts-service/construction-parts/{{id}}/submit';
